import axios from 'axios';

export default {
	state: {
		cartItems: [],
		price: []
	},
	mutations: {
		setCartItems (state, items) {
			state.cartItems = items;
		},
		setPrice (state, values) {
			state.price = values;
		},
	},
	actions: {
		async getCartItems ({ commit }) {
			try {
				const cartItems = await axios
					.post('/darkrogua/babylon/api/Cart@getCartItems')
					.then(response => (response.data));
				commit('setCartItems', cartItems);
			} catch (e) {
				commit('setError', e);
				throw e
			}
		},
		async getPrice ({ commit }) {
			try {
				const prices = await axios
					.post('/darkrogua/babylon/api/Cart@getPrice')
					.then(response => (response.data));
				commit('setPrice', prices);
			} catch (e) {
				commit('setError', e);
				throw e
			}
		},
		async updateCart ({ commit }, positions) {
			try {
				await axios
					.post('/darkrogua/babylon/api/Cart@updateCart', {positions})
					.then(response => (response.data));
			} catch (e) {
				commit('setError', e);
				throw e
			}
		},
		async removePositionCart ({ commit }, position) {
			try {
				await axios
					.post('/darkrogua/babylon/api/Cart@removePositionCart', {position})
					.then(response => (response.data));
			} catch (e) {
				commit('setError', e);
				throw e
			}
		},
	},
	getters: {
		cartItems: s => s.cartItems,
		price: s => s.price,
	}
}
